import { GridCol, GridRow } from "../components/table/TableList";
import { Groups } from "../model/Groups";

export class GroupSelect {
  main = () => {};

  // グループ選択後の表のカラム
  selectedColumns: GridCol[] = [
    {
      field: "name",
      headerName: "名称",
      style: "",
    },
    {
      field: "explanation",
      headerName: "説明",
      style: "",
    },
  ];

  // グループ選択後の表のデータ
  selectedRowList = (groupList: Groups[], topicState: string[]) => {
    const selectedGroupList = groupList?.filter((group) => topicState.includes(group.id));
    return selectedGroupList?.map<GridRow>((group) => {
      return {
        rowData: {
          name: (<div className="whitespace-normal">{group.name}</div>),
          explanation: (<div className="whitespace-normal">{group.explanation}</div>)
        },
      };
    }) ?? [];
  };

  // 配信先グループ選択モーダルカラム
  groupFormColumns: GridCol[] = [
    { field: "check", headerName: '', style: "w-max-12", },
    { field: "name", headerName: "名称", style: "", },
    { field: "explanation", headerName: "説明", style: "", },
  ];

  // 配信先グループ選択モーダルデータ
  groupFormRowList = (
    filteredGroupList: Groups[],
    onSelectTopic: (e: React.ChangeEvent<HTMLInputElement>, id: string) => void,
    topicState: string[]
  ) => {
    return filteredGroupList?.map<GridRow>((group) => {
      // グループ情報作成
      return {
        rowData: {
          check: (
            <input
              id={group.id}
              aria-describedby="group-description"
              name={group.id}
              type="checkbox"
              className="h-4 w-4 rounded border-gray-300 text-indigo-600 focus:ring-indigo-500"
              onChange={(e) => onSelectTopic(e, group.id)}
              disabled={group.deleteFlg}
              checked={topicState.includes(group.id)}
            />
          ),
          name: (<span className={group.deleteFlg ? "text-gray-300" : "text-gray-700"}>{group.name}</span>),
          explanation: (<span className={group.deleteFlg ? "text-gray-300" : "text-gray-700"}>{group.explanation}</span>),
        }
      }
    });
  };

  // 配信先グループ検索
  search = (
    e: any,
    groupList: Groups[],
    setFilteredGroupList: React.Dispatch<React.SetStateAction<Groups[]>>,
  ) => {
    const regex = new RegExp(e.target.value);
    const baseFilteredGroupList = groupList.filter((group) => !group.deleteFlg);
    if(e.target.value.length > 1){
      const filteredGroupList = baseFilteredGroupList.filter((group) => group.name?.match(regex) || group.nameKana?.match(regex));
      setFilteredGroupList(filteredGroupList);
    } else {
      setFilteredGroupList(baseFilteredGroupList);
    }
  };

  // グループ選択モーダルで選択されたステートを更新
  groupCheckedId = (
    e: React.ChangeEvent<HTMLInputElement>,
    id: string,
    groupCheckedIdList: string[],
    setGroupCheckedIdList: React.Dispatch<React.SetStateAction<string[]>>,
  ) => {
    if(e.target.checked){
      groupCheckedIdList.push(id);
      setGroupCheckedIdList([...new Set(groupCheckedIdList)]);
    } else {
      const filter = groupCheckedIdList.filter((checkedId: string) => checkedId !== id );
      setGroupCheckedIdList([...new Set(filter)]);
    }
  }
}